<template>
	<div class="c-member-item flex-center" @click="$emit('click')">
		<member-icon :icon="icon" :name="name" :current="current"></member-icon>
		<div class="flex-grow">
			<div class="flex-start-center">
				<p class="name ellipsis">{{name}}</p>
				<span v-if="tag" class="tag">{{tag}}</span>
			</div>
			<p class="post">{{post}}</p>
		</div>
		<a v-if="tel" class="tel" :href="`tel:${tel}`">
			<i class="tf">&#xe679;</i>
		</a>
		<a v-if="remove" class="remove flex-center" @click="$emit('remove')"><i class="tf">&#xe60f;</i></a>
	</div>
</template>

<script>
	export default {
		name: 'memberItem',

		props: {
			icon: String,
			name: String,
			tag: String,
			post: String,
			tel: String,
			current: Boolean,
			remove: Boolean
		},
		
		computed: {
			compName() {
				return this.name.substring(this.name.length - 2, this.name.length).split('');
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
